import { BrandingColorService as Api } from '../../../api/gen';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { helperSemanticColors } from './helper-semantic-colors';
import { BrandingColor, BrandingColorApiInterface } from 'shared/branding';
import { BrandingColorDtoCasts } from '../../model/company-settings/branding/branding-color';

@Injectable({ providedIn: 'root' })
export class BrandingColorService implements BrandingColorApiInterface {
  private readonly document = inject(DOCUMENT);

  constructor(private readonly brandingColorService: Api) {}

  getActiveBrandingColor(): Observable<BrandingColor> {
    return this.brandingColorService.brandingColorGet().pipe(
      map((dto) => BrandingColorDtoCasts.fromDto(dto)),
      tap((branding) => this.applySemanticColors(branding)),
      catchError((error: unknown) => {
        this.applySemanticColors();
        return throwError(() => error);
      }),
    );
  }
  private applySemanticColors(branding?: BrandingColor): void {
    for (const [token, value] of Object.entries(
      helperSemanticColors(branding),
    )) {
      this.document.documentElement.style.setProperty(token, value);
    }
  }
}
